import React, { useState } from 'react';
import { CloseOutline, AlertTriangleOutline, SuccessCircleOutline, BellOutline } from '@olist/design-system-icons';
import { ANIMATION_TIME_MILLISECONDS } from './constants.js';
import { ToastItemContainer, IconContainer } from './styles.js';
import { Box } from '../Box/Box.js';
import { ButtonIcon } from '../ButtonIcon/ButtonIcon.js';
import { Flex } from '../Flex/Flex.js';
import Link from '../Link/Link.js';
import '../Text/Caption/Caption.js';
import '../Text/DetailedSubheading/DetailedSubheading.js';
import '../Text/OverlineLg/OverlineLg.js';
import '../Text/OverlineMd/OverlineMd.js';
import '../Text/ParagraphLg/ParagraphLg.js';
import ParagraphMd from '../Text/ParagraphMd/ParagraphMd.js';
import '../Text/SectionHeading/SectionHeading.js';
import '../Text/SectionSubheading/SectionSubheading.js';
import '../Text/Title/Title.js';

function ToastItem({ id, message, variation = 'info', icon, link, hideInfoIcon = false, onClose, hide, }) {
    const [shouldHide, setShouldHide] = useState(false);
    const getIcon = () => {
        if (icon)
            return icon;
        if (variation === 'alert') {
            return React.createElement(AlertTriangleOutline, null);
        }
        if (variation === 'success') {
            return React.createElement(SuccessCircleOutline, null);
        }
        return React.createElement(BellOutline, null);
    };
    const handleClose = () => {
        setShouldHide(true);
        setTimeout(() => onClose(id), ANIMATION_TIME_MILLISECONDS);
    };
    return (React.createElement(ToastItemContainer, { "data-testid": `toast-${variation}`, shouldHide: hide || shouldHide },
        React.createElement(Flex, { justifyContent: "space-between" },
            React.createElement(Flex, { alignItems: "center" },
                !(variation === 'info' && hideInfoIcon) && (React.createElement(IconContainer, { "data-testid": `toast-icon-container-${variation}`, alignItems: "center", justifyContent: "center", minW: 48, h: 48, p: "inset.1xsmall", mr: "stack.small", color: "neutral.stronger", variation: variation }, getIcon())),
                React.createElement(Box, null,
                    React.createElement(ParagraphMd, null, message),
                    link && (React.createElement(Link, { href: link.href, type: "standalone", mt: "stack.1xsmall", target: link.target }, link.label)))),
            React.createElement(Box, null,
                React.createElement(ButtonIcon, { icon: React.createElement(CloseOutline, null), variation: "secondary", onClick: handleClose, "aria-label": "fechar" })))));
}

export { ToastItem };
